import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class AuthenticatedPslfDashboardIndexController extends Controller {
  queryParams = ['showEstimator'];

  // Debug/testing override: ?showEstimator=true forces the forgiveness estimator
  // tile to render regardless of the usual hero gating (PSLF forms / NSLDS data /
  // annual-reminder state). Read in the dashboard index component via the router.
  @tracked showEstimator: string | null = null;
}
